<template>
  <base-tabs-view
    :tabs="Tabs"
  />
</template>

<script>
import BaseTabsView from '@/components/shared/base/base-tabs-view'
import BaseTabsViewMixin from '@/mixins/base-tabs-view-mixin'

export default {
  name: 'BankStatements',
  components: {
    BaseTabsView
  },
  mixins: [
    BaseTabsViewMixin
  ],
  computed: {
    Tabs () {
      return [
        {
          component: 'bank-statements-overview',
          idComponent: this.constantMixin.menuItem.bankStatements.general,
          name: this.TextMixin_GetTab('overview')
        }
      ]
    }
  }
}
</script>
